import React, { useState, useCallback } from 'react'
import { CloudUpload } from '@material-ui/icons'
import { useDropzone } from 'react-dropzone' // Nova lib
import SimpleActionPopup from '../../../components/SimpleActionPopup'

const BulkUploadPopup = ({
    subgroup, 
    onClose, 
    onSubmit, 
    isLoading,  
    uploadProgress,
    uploadTotal,
}) => {
  const [files, setFiles] = useState([])

  // Função disparada quando arquivos são soltos ou selecionados
  const onDrop = useCallback(acceptedFiles => {
    setFiles(acceptedFiles)
  }, [])

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ 
    onDrop,
    accept: 'image/*', // Aceita apenas imagens
    disabled: isLoading // Desativa enquanto sobe
  })

  const handleUpload = () => {
    if (files.length === 0) return
    onSubmit(files)
  }

  const content = (
    <div className='text-center'>
      {/* Área de Drop */}
      <div 
        {...getRootProps()} 
        className={`border-2 border-dashed rounded-2xl p-10 transition-all cursor-pointer
          ${isDragActive ? 'border-purple-500 bg-purple-100 scale-105' : 'border-purple-200 bg-purple-50 hover:bg-purple-100'}
          ${isLoading ? 'opacity-50 cursor-not-allowed' : ''}`}
      >
        <input {...getInputProps()} />
        
        <CloudUpload style={{ fontSize: 60, color: isDragActive ? '#6b46c1' : 'var(--identity-1)' }} />
        
        <h3 className="mt-4 font-black text-purple-900">
          {isDragActive ? "SOLTE AS IMAGENS AQUI" : "Upload em Massa"}
        </h3>
        
        <p className="text-gray-500 text-xs mb-6">
          Arraste e solte as fotos ou clique para selecionar.<br/>
          O nome do arquivo será usado como título do produto.
        </p>
        
        {!isDragActive && (
          <span className="bg-purple-600 text-white px-8 py-3 rounded-xl font-bold shadow-md hover:bg-purple-700 transition-all">
            SELECIONAR ARQUIVOS
          </span>
        )}
        
        {files.length > 0 && !isDragActive && (
          <div className="mt-6 text-sm font-bold text-green-600 bg-white p-3 rounded-lg border border-green-100 animate-bounce">
            {files.length} arquivos selecionados!
          </div>
        )}
      </div>

      {/* Listagem rápida dos nomes (opcional, ajuda a saber o que está subindo) */}
      {files.length > 0 && (
        <div className="mt-4 max-h-32 overflow-y-auto text-left px-2">
            <p className="text-[10px] text-gray-400 font-bold uppercase">Arquivos na fila:</p>
            {files.slice(0, 3).map((f, i) => (
                <p key={i} className="text-[10px] text-gray-500 truncate">• {f.name}</p>
            ))}
            {files.length > 5 && <p className="text-[10px] text-gray-500">... e mais {files.length - 3}</p>}
        </div>
      )}
    </div>
  )

  return (
    <SimpleActionPopup
      title={`Subir em Massa para: ${subgroup?.title_pt}`}
      content={content}
      onClosePopup={onClose}
      secondActionButtonText={isLoading ? `SUBINDO (${uploadProgress}/${uploadTotal})` : "INICIAR UPLOAD"}
      onPressSecondActionButton={handleUpload}
      popupLoading={isLoading}
      containerStyle={{ maxWidth: '500px' }}
      // Note: Verifique se seu SimpleActionPopup suporta essas props de progresso
      withProgressBar={isLoading}
      progress={uploadProgress}
      total={uploadTotal}
    />
  )
}

export default BulkUploadPopup